import { Box, Button, Flex, Heading, Text, VStack, useColorModeValue, Link, Icon } from "@chakra-ui/react";
import { FaArrowRight, FaCalendarAlt, FaFileAlt } from "react-icons/fa";

interface NextStepsSectionProps {
    title: string;
}

interface NextStepsSectionProps {
    title : string;
    message: string;
    actionHeading: string;
    actionText: string;
    actionLabel: string;

}
export const NextStepsSection = ({title, message, actionHeading, actionText,actionLabel}: NextStepsSectionProps) => {
  const accentColor = useColorModeValue("blue.500", "blue.300");
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  return (
    <Box 
      as="section" 
      py={12} 
      bg={useColorModeValue("gray.50", "gray.700")}
      borderRadius="xl"
      mt={12}
    >
      <VStack spacing={6} maxW="3xl" mx="auto" px={{ base: 4, md: 8 }} textAlign="center">
        <Heading size="xl" bgGradient="linear(to-r, blue.400, purple.600)" bgClip="text">
        {title}        
        </Heading>
        
        <Text fontSize="lg" color={useColorModeValue("gray.600", "gray.300")}>
            {message}
        </Text>

        <Flex 
          direction={{ base: "column", md: "row" }} 
          gap={6} 
          w="full" 
          justify="center"
          mt={8}
        >

          <Box
            p={6}
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="lg"
            bg={cardBg}
            flex="1"
            minW={{ md: "300px" }}
          >
            <VStack spacing={4} align="start">
              <Icon as={FaCalendarAlt} boxSize={6} color={accentColor} />
              <Heading size="md">{actionHeading}</Heading>
              <Text>
                {actionText}
              </Text>
              <Button 
                as={Link} 
                href="/contact" 
                rightIcon={<FaArrowRight />} 
                colorScheme="blue"
                mt={4}
                w="full"
              >
                {actionLabel}
              </Button>
            </VStack>
          </Box>
        </Flex>

        
      </VStack>
    </Box>
  );
};

export default NextStepsSection;